var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrosshair = function SvgCrosshair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "crosshair_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".crosshair_svg__st0{clip-path:url(#crosshair_svg__SVGID_00000044860334729554023290000006897694704651076029_)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "crosshair_svg__SVGID_1_",
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "crosshair_svg__SVGID_00000117639697519618360510000003921484006578735798_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crosshair_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#crosshair_svg__SVGID_00000117639697519618360510000003921484006578735798_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1c0-.6.4-1 1-1s1 .4 1 1v1.6c3.3.4 6 3.1 6.4 6.4H19c.6 0 1 .4 1 1s-.4 1-1 1h-1.6c-.4 3.3-3.1 6-6.4 6.4V19c0 .6-.4 1-1 1s-1-.4-1-1v-1.6C5.7 17 3 14.3 2.6 11H1c-.6 0-1-.4-1-1s.4-1 1-1h1.6C3 5.7 5.7 3 9 2.6V1zm6.5 9c0 3-2.5 5.5-5.5 5.5S4.5 13 4.5 10 7 4.5 10 4.5 15.5 7 15.5 10zM10 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  })));
};
export default SvgCrosshair;